import { z } from "zod";
export const UserRole = z.enum(["Admin", "User"]);
export type UserRole = z.infer<typeof UserRole>;
export const allUserRoles = new Set<UserRole>(UserRole.options);
